import { RelatedTag } from '@empathy/search-types';

export function amendQueryWithRelatedTags(query: string, relatedTags: RelatedTag[]): string {
  return relatedTags.reduce((chain: string, rt: RelatedTag) => `${chain} ${rt.tag}`, query).trim();
}
